module.exports = __webpack_public_path__ + "img/linkedin-icon.dab9b445.svg";